import { Injectable } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient, HttpHeaders} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LogSharedService {
  logApiHeaders = new HttpHeaders({'Content-Type':'application/json; charset=utf-8','accept': 'application/ld+json'})
  requestOptionsGet = {headers: this.logApiHeaders, params: {}};
  requestOptionsPost = {headers: this.logApiHeaders};
  constructor(private httpService: HttpClient) { }
  get(endPoint, params = {}) {
    let requestUrl=environment.midOfficeApiUrl +'/log/' + endPoint;
    this.requestOptionsGet.params = params;
    return this.httpService.get<any>(requestUrl, this.requestOptionsGet).pipe( );
  }
  post(endPoint, params = {}) {
    let requestUrl=environment.midOfficeApiUrl +'/log/' + endPoint;
    return this.httpService.post<any>(requestUrl,params, this.requestOptionsPost).pipe( );
  }
  put(endPoint, params = {}) {
    let requestUrl=environment.midOfficeApiUrl +'/log/' + endPoint;
    return this.httpService.put<any>(requestUrl,params, this.requestOptionsPost).pipe( );
  }
  delete(endPoint, params = {}) {
    let requestUrl=environment.midOfficeApiUrl +'/log/' + endPoint;
    this.requestOptionsGet.params = params;
    return this.httpService.delete<any>(requestUrl, this.requestOptionsGet).pipe( );
  }
}
